import * as React from 'react';
export const IcUnlink = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12.55 8.3l1.94-1.94c.33-.33.79-.48 1.3-.45.57.04 1.12.3 1.56.75.44.44.71 1 .74 1.56.04.52-.12.98-.45 1.3l-1.28 1.28c-.3.3-.36.73-.21 1.1l.52.52c.36.16.8.09 1.1-.21l1.28-1.28c.74-.74 1.1-1.75 1.03-2.85-.07-1.05-.54-2.06-1.33-2.84a4.52 4.52 0 00-2.84-1.33c-1.1-.08-2.12.29-2.85 1.03l-1.93 1.93 1.43 1.43h-.01zM5.26 3.84s-.03-.05-.05-.08l-.48-.48a.996.996 0 10-1.41 1.41l5.66 5.66c-.01.17-.03.33-.02.51.07 1.05.54 2.06 1.33 2.84.2.2.45.29.71.29.26 0 .51-.1.71-.29.11-.11.18-.25.23-.39l.89.89c-.07.13-.15.25-.25.36l-3.07 3.07c-.32.33-.78.48-1.3.45-.57-.04-1.12-.3-1.56-.75-.44-.44-.71-1-.74-1.56-.04-.52.12-.98.45-1.3l1.28-1.28a.996.996 0 10-1.41-1.41l-1.28 1.28c-.74.74-1.1 1.75-1.03 2.85.07 1.05.54 2.06 1.33 2.84a4.52 4.52 0 002.84 1.33h.29c.99 0 1.89-.36 2.57-1.04l3.07-3.07c.1-.1.17-.22.26-.33l5.03 5.03c.2.2.45.29.71.29.26 0 .51-.1.71-.29.37-.37.38-.94.05-1.34L5.26 3.84z'
      fill='currentColor'
    />
  </svg>
);
